
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as faq_gOBK6lc5vAa167ItG3WL1JAZKOfMRJ_vPf1e_VYSBgMeta } from "/codebuild/output/src713742779/src/src/pages/faq.vue?macro=true";
import { default as menuBe45ULaeq0TmD25fgpfFANNatJpIfSsDsq2Fez3T4EEMeta } from "/codebuild/output/src713742779/src/src/pages/menu.vue?macro=true";
import { default as indexEICxqwHANEgqCKkDZseouPr_PBKDnLahuyPBspj7GYwMeta } from "/codebuild/output/src713742779/src/src/pages/index.vue?macro=true";
import { default as contactejikXQwQBqpUz1olbjVSv_45o0ew3R3zPOUf_3BRFJpW8Meta } from "/codebuild/output/src713742779/src/src/pages/contact.vue?macro=true";
import { default as tutorialmLdVwy2m1_6xque0Gz9xKqz_kDl_45yA__8UOMMP6tarcMeta } from "/codebuild/output/src713742779/src/src/pages/tutorial.vue?macro=true";
import { default as agreementW6JrYDy3ZmzzrXMELSZrTK2J4tgpW4k0BseygqXq1MkMeta } from "/codebuild/output/src713742779/src/src/pages/agreement.vue?macro=true";
import { default as about_45passTnYoN_45gygq0ViUsmZ2HriVKY57jEk6F1RdUA809pDtUMeta } from "/codebuild/output/src713742779/src/src/pages/about-pass.vue?macro=true";
import { default as index_45oJyzsDwO9u1U_mvg_ZCUYon2zZisZDumCSg9e6A6YMMeta } from "/codebuild/output/src713742779/src/src/pages/card/index.vue?macro=true";
import { default as _91id_93b4kHGiD_j2K1CaoLCF_45_vyHmEqadPAUpPkJg9HjZptYMeta } from "/codebuild/output/src713742779/src/src/pages/coupon/[id].vue?macro=true";
import { default as maintenance1uDDP7fKEumpfyDFs8VKzEY2lfq76UZniXCbeaJoAqoMeta } from "/codebuild/output/src713742779/src/src/pages/maintenance.vue?macro=true";
import { default as _91id_93NSiow7ctbRKcPMeHU7xXPB_454oeyPMavKNlJtU8OWP6EMeta } from "/codebuild/output/src713742779/src/src/pages/notice/[id].vue?macro=true";
import { default as indexdDbvAQ5bx_kQgTIP0atELWR9b36vyBUtVoUk5k2cfxoMeta } from "/codebuild/output/src713742779/src/src/pages/coupon/index.vue?macro=true";
import { default as indexdh7j9KrTnEjPj22S1KW97OArGOx5p12G0z1TA72__45xoMeta } from "/codebuild/output/src713742779/src/src/pages/mypage/index.vue?macro=true";
import { default as indexoRky0RknhXH3VNsbiDD8hbHYxiwcLnt6RHstayFrTmgMeta } from "/codebuild/output/src713742779/src/src/pages/notice/index.vue?macro=true";
import { default as _91id_93T6ZsKctSp76nIUzsqoqU3x7wFY1QsiKRrv9wC1d5Bf0Meta } from "/codebuild/output/src713742779/src/src/pages/parking/[id].vue?macro=true";
import { default as index8NjNOugnjoqQna6wu5zK23__45PNBAAqKcJkpXf8ydg5sMeta } from "/codebuild/output/src713742779/src/src/pages/history/index.vue?macro=true";
import { default as indextTCfycccv1n0DuJgXT95gEiD2Smrwu7U6qQmIMECg1IMeta } from "/codebuild/output/src713742779/src/src/pages/monthly/index.vue?macro=true";
import { default as index2qCG72m_45q5c0GtffvBnpaEqdrIPLpoOnzKm22_45Hl7VkMeta } from "/codebuild/output/src713742779/src/src/pages/sign-in/index.vue?macro=true";
import { default as indexj0OQrHJDsn5nX_456ysmi3r1zOyB1l78KI9hFKFvpp_O0Meta } from "/codebuild/output/src713742779/src/src/pages/sign-up/index.vue?macro=true";
import { default as about_45yumenaviOJDirVP8_kTnEIhs3rBKPhrqyT5O6Gse_45q67ixwdst8Meta } from "/codebuild/output/src713742779/src/src/pages/about-yumenavi.vue?macro=true";
import { default as edit5Uybcg2tk5wLcXzpTRoNzTYA66gh3byPT4Sl8IZJnUUMeta } from "/codebuild/output/src713742779/src/src/pages/card/[id]/edit.vue?macro=true";
import { default as pass_45agreementLKkcSxGCjxfbXOnz_xSEQmetPzlIcPezWuxE4OrV7G4Meta } from "/codebuild/output/src713742779/src/src/pages/pass-agreement.vue?macro=true";
import { default as index1Nz0K6S3nG84s_IysQAFxX6aj3gQLLh31a_ZILttLBMMeta } from "/codebuild/output/src713742779/src/src/pages/card/[id]/index.vue?macro=true";
import { default as confirm_453dMJFqsL1s7HFxBssu0vGDQxPMQyQl4FtMX_45o15uncFGMMeta } from "/codebuild/output/src713742779/src/src/pages/card/confirm-3d.vue?macro=true";
import { default as confirmyJpgtcSEcmJZC9DJIgo3KvcAHaRqVSMbrzso7lLqFvoMeta } from "/codebuild/output/src713742779/src/src/pages/card/[id]/confirm.vue?macro=true";
import { default as indexYAtmodo3CUXkkx7Yoa_ZPDc76FnlYaT8JJIq_eyWnVkMeta } from "/codebuild/output/src713742779/src/src/pages/card/create/index.vue?macro=true";
import { default as indexOyF9C_7qMOkOBckpx_F74qohNptHEqRvbL2lf2kXirYMeta } from "/codebuild/output/src713742779/src/src/pages/mypage/pass/index.vue?macro=true";
import { default as confirmgEqJatVDMh9_57n1cboHaXRrtq5OUK19VroQBoAotTwMeta } from "/codebuild/output/src713742779/src/src/pages/membership/confirm.vue?macro=true";
import { default as confirm87p2D9ee6WNYlKWuVftUiN_BjAwTV9BeLaBUqcQX3joMeta } from "/codebuild/output/src713742779/src/src/pages/card/create/confirm.vue?macro=true";
import { default as completerbVwLu36ZL8GDfCHY5D_RhxdvYJK3zgATXtguArXWbQMeta } from "/codebuild/output/src713742779/src/src/pages/membership/complete.vue?macro=true";
import { default as registerBKuq_TYf4MWDjEqqLoSn5lhdf0e8a5qoZ0SWE4_45YIHMMeta } from "/codebuild/output/src713742779/src/src/pages/membership/register.vue?macro=true";
import { default as _91id_93AtP7qauk831ruEo81Kvi2ACHLsweS_FIUfhvzkifJMwMeta } from "/codebuild/output/src713742779/src/src/pages/monthly/notice/[id].vue?macro=true";
import { default as confirmh6XEIRGLi8NiDd2f1PQKspI4pFp5ciVJ4WMAY6l_45yUgMeta } from "/codebuild/output/src713742779/src/src/pages/contact-form/confirm.vue?macro=true";
import { default as _91id_93_45fGPCRlGYmjdIcUDwFdIZmTa1_45LeONmnwLiJSANIXKgMeta } from "/codebuild/output/src713742779/src/src/pages/history/receipt/[id].vue?macro=true";
import { default as indexfwKkVrhYKbA3JYcLTDXEZnKEMWymNJ_45h0Uks30ADr_oMeta } from "/codebuild/output/src713742779/src/src/pages/monthly/notice/index.vue?macro=true";
import { default as confirm_45codeLMje2T8L_cF71tf1AclMsnmX9KBYY9OdfO1h0nK7mtIMeta } from "/codebuild/output/src713742779/src/src/pages/sign-in/confirm-code.vue?macro=true";
import { default as confirm_45codeXqU3cY5wXlZeToYpLURW4onIDvESFGbrfpsK82RIzC0Meta } from "/codebuild/output/src713742779/src/src/pages/sign-up/confirm-code.vue?macro=true";
import { default as completeVMy5Kq_HmSdhXtpd0DPuzX_oHgq5gzkmPrzVRbgp_fsMeta } from "/codebuild/output/src713742779/src/src/pages/contact-form/complete.vue?macro=true";
import { default as register615wWZiswzGxZU62nHSGs5yXNbcC44_45imjpk_1rhQ_AMeta } from "/codebuild/output/src713742779/src/src/pages/contact-form/register.vue?macro=true";
import { default as complete9vwnKt_iRrxPkqip_45APD_45KORVtyZNnBBfKj_45lN63RasMeta } from "/codebuild/output/src713742779/src/src/pages/monthly/cancel/complete.vue?macro=true";
import { default as indexZZL8R_tXxyNXO4Uh2Y4BKhPjrUU177oj11q_45g_7dk90Meta } from "/codebuild/output/src713742779/src/src/pages/mypage/membership/index.vue?macro=true";
import { default as confirmc5YSo3zEvKnfw5yT0jW_kKabiOoKXp9t9zNddZnUBvUMeta } from "/codebuild/output/src713742779/src/src/pages/mypage/sign-out/confirm.vue?macro=true";
import { default as complete36IqU6CyBfHuJwy2DDgnaAIfJBMXQqEwlJRL6Uti9KIMeta } from "/codebuild/output/src713742779/src/src/pages/reset-password/complete.vue?macro=true";
import { default as indexW2PdcguByZbus_45bWUAkRZ2Iold08FK6IzXQdrEDLr0YMeta } from "/codebuild/output/src713742779/src/src/pages/mypage/integration/index.vue?macro=true";
import { default as _91id_931oaQ6Ok_45GT9FI_45BszvLu3AglyC5MDtt9Le_zvKjf_45lYMeta } from "/codebuild/output/src713742779/src/src/pages/mypage/pass/receipt/[id].vue?macro=true";
import { default as completeRVLMi6uaH09LS8YEaOcyiSrsyXISezn_q_45rJbaEOYmoMeta } from "/codebuild/output/src713742779/src/src/pages/mypage/sign-out/complete.vue?macro=true";
import { default as edit_45card_45aliaspqfl8_45LqLPBWJM5TSJIinMHZ78ayUlzuSl_7ua8qgX4Meta } from "/codebuild/output/src713742779/src/src/pages/card/[id]/edit-card-alias.vue?macro=true";
import { default as samplebsz837IQPyMbutjpeH_45ICiCBK5iw3Tl7spa3HNF3bpkMeta } from "/codebuild/output/src713742779/src/src/pages/mypage/integration/sample.vue?macro=true";
import { default as send_45emailOTVPPPP2tgkUNaM9lrCFC7mqCOcPZk4NFsIsqVumg3AMeta } from "/codebuild/output/src713742779/src/src/pages/reset-password/send-email.vue?macro=true";
import { default as confirmaa81GcWeyte_450wWxsxNq19s1EDN3z5P49KQ6X_BW90gMeta } from "/codebuild/output/src713742779/src/src/pages/mypage/unsubscribe/confirm.vue?macro=true";
import { default as consentK5nWMHIzQvFyh5ItjLiCOOoSTobA7ofjN0RHICGRKmAMeta } from "/codebuild/output/src713742779/src/src/pages/mypage/unsubscribe/consent.vue?macro=true";
import { default as confirmhkAVqWLwJnwOhXCxWs0oASEYWYKzdMT5g6dSKCyR0iIMeta } from "/codebuild/output/src713742779/src/src/pages/membership/yumenavi/confirm.vue?macro=true";
import { default as duedatefc_XaHSKWAXu3vHkPwIf6hPegZQb5uXepykCDZ7FqvQMeta } from "/codebuild/output/src713742779/src/src/pages/monthly/application/duedate.vue?macro=true";
import { default as completeb9OLXV5ZCSiFmG7JgPZAf5VcckYc01RlsnRKgxXtoRAMeta } from "/codebuild/output/src713742779/src/src/pages/mypage/unsubscribe/complete.vue?macro=true";
import { default as confirm_45codeGGaIdHCTUxhjSB6_45Z1Irfb2yMkPrCjSYmn6ymODVvYsMeta } from "/codebuild/output/src713742779/src/src/pages/reset-password/confirm-code.vue?macro=true";
import { default as new_45passwordabZ2pprtQiMhntE2_4572WwfTcnSmZsojQWrJUWogF_7kMeta } from "/codebuild/output/src713742779/src/src/pages/reset-password/new-password.vue?macro=true";
import { default as confirm_45card_45aliasOweX29OdLZ40Z3jSpjXBbrcnhVDPO8VTurAemnsYA2wMeta } from "/codebuild/output/src713742779/src/src/pages/card/[id]/confirm-card-alias.vue?macro=true";
import { default as registerTad80Crxmhnk0fuHdcFCZAg8MUD3hdJX4Y14QwnYVIMMeta } from "/codebuild/output/src713742779/src/src/pages/membership/yumenavi/register.vue?macro=true";
import { default as confirm_45code_45SHib8baAeZhFw8F3ajvQoaOcYpJf5xO8gCjB3bms2MMeta } from "/codebuild/output/src713742779/src/src/pages/membership/yumenavi/confirm-code.vue?macro=true";
import { default as indexIElZUgGUAHoNY6I_45_45aHZjQNKrO_zrlXt_kw4V_45Rti_45wMeta } from "/codebuild/output/src713742779/src/src/pages/mypage/membership/email-edit/index.vue?macro=true";
import { default as indexMt38VKwoyCDZjrJ0qDOIrh1mua4JOmwbkS__45fQBzEJEMeta } from "/codebuild/output/src713742779/src/src/pages/monthly/close/[applicationId]/index.vue?macro=true";
import { default as indexmDEvTneMtNgg5_45GORUkl7gZpQcoUvKPJTfiPm3cY78QMeta } from "/codebuild/output/src713742779/src/src/pages/mypage/membership/others-edit/index.vue?macro=true";
import { default as indexVgumjGh3JyTKpUnSaIpAPEtD1WRiJqia03PEGpJX94sMeta } from "/codebuild/output/src713742779/src/src/pages/monthly/cancel/[applicationId]/index.vue?macro=true";
import { default as updatecvsDmhf6Nrqc8LEbtymbBwrvCb2S5RDETVSHsK_45En0cMeta } from "/codebuild/output/src713742779/src/src/pages/mypage/membership/others-edit/update.vue?macro=true";
import { default as complete_45SOM0VhVOxO0DUv_riwPomgeTfUXQwzH5jNJn9QDR6QMeta } from "/codebuild/output/src713742779/src/src/pages/mypage/membership/email-edit/complete.vue?macro=true";
import { default as confirmLNKOGWTxDUjlQVSRzP1B_Yx3rd_45s7TUxVLaGFo1RYhcMeta } from "/codebuild/output/src713742779/src/src/pages/mypage/membership/others-edit/confirm.vue?macro=true";
import { default as index4XjPdwrOV0YVe3ws45e8MxjVf_fPF5iX1l8bNtuSjbMMeta } from "/codebuild/output/src713742779/src/src/pages/monthly/payments/[applicationId]/index.vue?macro=true";
import { default as completehrX9DtbO6vXLPYkLrkX67ki1P6_lryv_45UL9Nwz_45JAPMMeta } from "/codebuild/output/src713742779/src/src/pages/mypage/membership/others-edit/complete.vue?macro=true";
import { default as update5_45OdP5U2sHGJ_DG7qpL3UTXtaEiJlYDfaJ5JMe52hlkMeta } from "/codebuild/output/src713742779/src/src/pages/mypage/membership/password-edit/update.vue?macro=true";
import { default as indexrUM4AKKHfTc5VjE5ef1DtUWY5pef0NwbRS3gNkbu0cQMeta } from "/codebuild/output/src713742779/src/src/pages/monthly/applicant/[applicationId]/index.vue?macro=true";
import { default as indexEf7_45MRx6xtOzUql1nBtkUHX4PU_45M8CV7BN1hAbh8Q8kMeta } from "/codebuild/output/src713742779/src/src/pages/monthly/preapplication/[parkingId]/index.vue?macro=true";
import { default as completetWpvWFp1Ct3xIjf_XFIxa3_OCxKSjb_454KYDTxljjFpQMeta } from "/codebuild/output/src713742779/src/src/pages/mypage/membership/password-edit/complete.vue?macro=true";
import { default as indexg_Me7_45uwl97noh40_45Qqkq7wyJ_45sjrbxKgB5CKxNTPf0Meta } from "/codebuild/output/src713742779/src/src/pages/monthly/application/[applicationId]/index.vue?macro=true";
import { default as confirm_45code2FPgx5f_pVaAtQp3gSff_P525aBWEURHGOZ_45qWM8Hb0Meta } from "/codebuild/output/src713742779/src/src/pages/mypage/membership/email-edit/confirm-code.vue?macro=true";
import { default as indexILBV1obW3eILVvjMZakFqD9qGVZBNWxjPIzkepDhPw4Meta } from "/codebuild/output/src713742779/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue?macro=true";
import { default as indexyR1cTFAzC_45gNXKpLLV08k1cDUEZyx6D3OuE82UTPchkMeta } from "/codebuild/output/src713742779/src/src/pages/monthly/payments/method/[applicationId]/index.vue?macro=true";
import { default as indexDTq_45Me0rAoAGjg2sZRH6HF7FjJc3eNwiS9PltwdPVYoMeta } from "/codebuild/output/src713742779/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue?macro=true";
import { default as updateXiQ2D0JOCGrAKEUKpldZr5ScUZFeiRTtcB_45Jfefcj6sMeta } from "/codebuild/output/src713742779/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue?macro=true";
import { default as confirm0aKPoyd9ifpDnSHCt8YOwd7LO6kf6lpH5MYwN60S8WMMeta } from "/codebuild/output/src713742779/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue?macro=true";
export default [
  {
    name: "faq",
    path: "/faq",
    component: () => import("/codebuild/output/src713742779/src/src/pages/faq.vue")
  },
  {
    name: "menu",
    path: "/menu",
    meta: menuBe45ULaeq0TmD25fgpfFANNatJpIfSsDsq2Fez3T4EEMeta || {},
    component: () => import("/codebuild/output/src713742779/src/src/pages/menu.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexEICxqwHANEgqCKkDZseouPr_PBKDnLahuyPBspj7GYwMeta || {},
    component: () => import("/codebuild/output/src713742779/src/src/pages/index.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/codebuild/output/src713742779/src/src/pages/contact.vue")
  },
  {
    name: "tutorial",
    path: "/tutorial",
    component: () => import("/codebuild/output/src713742779/src/src/pages/tutorial.vue")
  },
  {
    name: "agreement",
    path: "/agreement",
    component: () => import("/codebuild/output/src713742779/src/src/pages/agreement.vue")
  },
  {
    name: "about-pass",
    path: "/about-pass",
    component: () => import("/codebuild/output/src713742779/src/src/pages/about-pass.vue")
  },
  {
    name: "card",
    path: "/card",
    component: () => import("/codebuild/output/src713742779/src/src/pages/card/index.vue")
  },
  {
    name: "coupon-id",
    path: "/coupon/:id()",
    component: () => import("/codebuild/output/src713742779/src/src/pages/coupon/[id].vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    component: () => import("/codebuild/output/src713742779/src/src/pages/maintenance.vue")
  },
  {
    name: "notice-id",
    path: "/notice/:id()",
    component: () => import("/codebuild/output/src713742779/src/src/pages/notice/[id].vue")
  },
  {
    name: "coupon",
    path: "/coupon",
    meta: { ...(indexdDbvAQ5bx_kQgTIP0atELWR9b36vyBUtVoUk5k2cfxoMeta || {}), ...{"middleware":["coupon-params"]} },
    component: () => import("/codebuild/output/src713742779/src/src/pages/coupon/index.vue")
  },
  {
    name: "mypage",
    path: "/mypage",
    meta: {"middleware":"unsubscribe-store-control"},
    component: () => import("/codebuild/output/src713742779/src/src/pages/mypage/index.vue")
  },
  {
    name: "notice",
    path: "/notice",
    meta: {"middleware":["notice-params"]},
    component: () => import("/codebuild/output/src713742779/src/src/pages/notice/index.vue")
  },
  {
    name: "parking-id",
    path: "/parking/:id()",
    meta: {"middleware":["set-redirect-url","payment-step"]},
    component: () => import("/codebuild/output/src713742779/src/src/pages/parking/[id].vue")
  },
  {
    name: "history",
    path: "/history",
    meta: { ...(index8NjNOugnjoqQna6wu5zK23__45PNBAAqKcJkpXf8ydg5sMeta || {}), ...{"middleware":["payment-params"]} },
    component: () => import("/codebuild/output/src713742779/src/src/pages/history/index.vue")
  },
  {
    name: "monthly",
    path: "/monthly",
    component: () => import("/codebuild/output/src713742779/src/src/pages/monthly/index.vue")
  },
  {
    name: "sign-in",
    path: "/sign-in",
    meta: index2qCG72m_45q5c0GtffvBnpaEqdrIPLpoOnzKm22_45Hl7VkMeta || {},
    component: () => import("/codebuild/output/src713742779/src/src/pages/sign-in/index.vue")
  },
  {
    name: "sign-up",
    path: "/sign-up",
    meta: indexj0OQrHJDsn5nX_456ysmi3r1zOyB1l78KI9hFKFvpp_O0Meta || {},
    component: () => import("/codebuild/output/src713742779/src/src/pages/sign-up/index.vue")
  },
  {
    name: "about-yumenavi",
    path: "/about-yumenavi",
    component: () => import("/codebuild/output/src713742779/src/src/pages/about-yumenavi.vue")
  },
  {
    name: "card-id-edit",
    path: "/card/:id()/edit",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src713742779/src/src/pages/card/[id]/edit.vue")
  },
  {
    name: "pass-agreement",
    path: "/pass-agreement",
    component: () => import("/codebuild/output/src713742779/src/src/pages/pass-agreement.vue")
  },
  {
    name: "card-id",
    path: "/card/:id()",
    component: () => import("/codebuild/output/src713742779/src/src/pages/card/[id]/index.vue")
  },
  {
    name: "card-confirm-3d",
    path: "/card/confirm-3d",
    component: () => import("/codebuild/output/src713742779/src/src/pages/card/confirm-3d.vue")
  },
  {
    name: "card-id-confirm",
    path: "/card/:id()/confirm",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src713742779/src/src/pages/card/[id]/confirm.vue")
  },
  {
    name: "card-create",
    path: "/card/create",
    meta: indexYAtmodo3CUXkkx7Yoa_ZPDc76FnlYaT8JJIq_eyWnVkMeta || {},
    component: () => import("/codebuild/output/src713742779/src/src/pages/card/create/index.vue")
  },
  {
    name: "mypage-pass",
    path: "/mypage/pass",
    meta: {"middleware":["pass-payment-params"]},
    component: () => import("/codebuild/output/src713742779/src/src/pages/mypage/pass/index.vue")
  },
  {
    name: "membership-confirm",
    path: "/membership/confirm",
    meta: confirmgEqJatVDMh9_57n1cboHaXRrtq5OUK19VroQBoAotTwMeta || {},
    component: () => import("/codebuild/output/src713742779/src/src/pages/membership/confirm.vue")
  },
  {
    name: "card-create-confirm",
    path: "/card/create/confirm",
    meta: { ...(confirm87p2D9ee6WNYlKWuVftUiN_BjAwTV9BeLaBUqcQX3joMeta || {}), ...{"middleware":["editing-card"]} },
    component: () => import("/codebuild/output/src713742779/src/src/pages/card/create/confirm.vue")
  },
  {
    name: "membership-complete",
    path: "/membership/complete",
    meta: completerbVwLu36ZL8GDfCHY5D_RhxdvYJK3zgATXtguArXWbQMeta || {},
    component: () => import("/codebuild/output/src713742779/src/src/pages/membership/complete.vue")
  },
  {
    name: "membership-register",
    path: "/membership/register",
    meta: registerBKuq_TYf4MWDjEqqLoSn5lhdf0e8a5qoZ0SWE4_45YIHMMeta || {},
    component: () => import("/codebuild/output/src713742779/src/src/pages/membership/register.vue")
  },
  {
    name: "monthly-notice-id",
    path: "/monthly/notice/:id()",
    component: () => import("/codebuild/output/src713742779/src/src/pages/monthly/notice/[id].vue")
  },
  {
    name: "contact-form-confirm",
    path: "/contact-form/confirm",
    meta: confirmh6XEIRGLi8NiDd2f1PQKspI4pFp5ciVJ4WMAY6l_45yUgMeta || {},
    component: () => import("/codebuild/output/src713742779/src/src/pages/contact-form/confirm.vue")
  },
  {
    name: "history-receipt-id",
    path: "/history/receipt/:id()",
    component: () => import("/codebuild/output/src713742779/src/src/pages/history/receipt/[id].vue")
  },
  {
    name: "monthly-notice",
    path: "/monthly/notice",
    component: () => import("/codebuild/output/src713742779/src/src/pages/monthly/notice/index.vue")
  },
  {
    name: "sign-in-confirm-code",
    path: "/sign-in/confirm-code",
    meta: confirm_45codeLMje2T8L_cF71tf1AclMsnmX9KBYY9OdfO1h0nK7mtIMeta || {},
    component: () => import("/codebuild/output/src713742779/src/src/pages/sign-in/confirm-code.vue")
  },
  {
    name: "sign-up-confirm-code",
    path: "/sign-up/confirm-code",
    meta: confirm_45codeXqU3cY5wXlZeToYpLURW4onIDvESFGbrfpsK82RIzC0Meta || {},
    component: () => import("/codebuild/output/src713742779/src/src/pages/sign-up/confirm-code.vue")
  },
  {
    name: "contact-form-complete",
    path: "/contact-form/complete",
    meta: completeVMy5Kq_HmSdhXtpd0DPuzX_oHgq5gzkmPrzVRbgp_fsMeta || {},
    component: () => import("/codebuild/output/src713742779/src/src/pages/contact-form/complete.vue")
  },
  {
    name: "contact-form-register",
    path: "/contact-form/register",
    meta: register615wWZiswzGxZU62nHSGs5yXNbcC44_45imjpk_1rhQ_AMeta || {},
    component: () => import("/codebuild/output/src713742779/src/src/pages/contact-form/register.vue")
  },
  {
    name: "monthly-cancel-complete",
    path: "/monthly/cancel/complete",
    component: () => import("/codebuild/output/src713742779/src/src/pages/monthly/cancel/complete.vue")
  },
  {
    name: "mypage-membership",
    path: "/mypage/membership",
    component: () => import("/codebuild/output/src713742779/src/src/pages/mypage/membership/index.vue")
  },
  {
    name: "mypage-sign-out-confirm",
    path: "/mypage/sign-out/confirm",
    meta: { ...(confirmc5YSo3zEvKnfw5yT0jW_kKabiOoKXp9t9zNddZnUBvUMeta || {}), ...{"middleware":"logout-control"} },
    component: () => import("/codebuild/output/src713742779/src/src/pages/mypage/sign-out/confirm.vue")
  },
  {
    name: "reset-password-complete",
    path: "/reset-password/complete",
    meta: complete36IqU6CyBfHuJwy2DDgnaAIfJBMXQqEwlJRL6Uti9KIMeta || {},
    component: () => import("/codebuild/output/src713742779/src/src/pages/reset-password/complete.vue")
  },
  {
    name: "mypage-integration",
    path: "/mypage/integration",
    meta: { ...(indexW2PdcguByZbus_45bWUAkRZ2Iold08FK6IzXQdrEDLr0YMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src713742779/src/src/pages/mypage/integration/index.vue")
  },
  {
    name: "mypage-pass-receipt-id",
    path: "/mypage/pass/receipt/:id()",
    component: () => import("/codebuild/output/src713742779/src/src/pages/mypage/pass/receipt/[id].vue")
  },
  {
    name: "mypage-sign-out-complete",
    path: "/mypage/sign-out/complete",
    meta: completeRVLMi6uaH09LS8YEaOcyiSrsyXISezn_q_45rJbaEOYmoMeta || {},
    component: () => import("/codebuild/output/src713742779/src/src/pages/mypage/sign-out/complete.vue")
  },
  {
    name: "card-id-edit-card-alias",
    path: "/card/:id()/edit-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src713742779/src/src/pages/card/[id]/edit-card-alias.vue")
  },
  {
    name: "mypage-integration-sample",
    path: "/mypage/integration/sample",
    meta: { ...(samplebsz837IQPyMbutjpeH_45ICiCBK5iw3Tl7spa3HNF3bpkMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src713742779/src/src/pages/mypage/integration/sample.vue")
  },
  {
    name: "reset-password-send-email",
    path: "/reset-password/send-email",
    meta: send_45emailOTVPPPP2tgkUNaM9lrCFC7mqCOcPZk4NFsIsqVumg3AMeta || {},
    component: () => import("/codebuild/output/src713742779/src/src/pages/reset-password/send-email.vue")
  },
  {
    name: "mypage-unsubscribe-confirm",
    path: "/mypage/unsubscribe/confirm",
    meta: { ...(confirmaa81GcWeyte_450wWxsxNq19s1EDN3z5P49KQ6X_BW90gMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src713742779/src/src/pages/mypage/unsubscribe/confirm.vue")
  },
  {
    name: "mypage-unsubscribe-consent",
    path: "/mypage/unsubscribe/consent",
    meta: { ...(consentK5nWMHIzQvFyh5ItjLiCOOoSTobA7ofjN0RHICGRKmAMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src713742779/src/src/pages/mypage/unsubscribe/consent.vue")
  },
  {
    name: "membership-yumenavi-confirm",
    path: "/membership/yumenavi/confirm",
    meta: confirmhkAVqWLwJnwOhXCxWs0oASEYWYKzdMT5g6dSKCyR0iIMeta || {},
    component: () => import("/codebuild/output/src713742779/src/src/pages/membership/yumenavi/confirm.vue")
  },
  {
    name: "monthly-application-duedate",
    path: "/monthly/application/duedate",
    component: () => import("/codebuild/output/src713742779/src/src/pages/monthly/application/duedate.vue")
  },
  {
    name: "mypage-unsubscribe-complete",
    path: "/mypage/unsubscribe/complete",
    meta: { ...(completeb9OLXV5ZCSiFmG7JgPZAf5VcckYc01RlsnRKgxXtoRAMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src713742779/src/src/pages/mypage/unsubscribe/complete.vue")
  },
  {
    name: "reset-password-confirm-code",
    path: "/reset-password/confirm-code",
    meta: confirm_45codeGGaIdHCTUxhjSB6_45Z1Irfb2yMkPrCjSYmn6ymODVvYsMeta || {},
    component: () => import("/codebuild/output/src713742779/src/src/pages/reset-password/confirm-code.vue")
  },
  {
    name: "reset-password-new-password",
    path: "/reset-password/new-password",
    meta: new_45passwordabZ2pprtQiMhntE2_4572WwfTcnSmZsojQWrJUWogF_7kMeta || {},
    component: () => import("/codebuild/output/src713742779/src/src/pages/reset-password/new-password.vue")
  },
  {
    name: "card-id-confirm-card-alias",
    path: "/card/:id()/confirm-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src713742779/src/src/pages/card/[id]/confirm-card-alias.vue")
  },
  {
    name: "membership-yumenavi-register",
    path: "/membership/yumenavi/register",
    meta: registerTad80Crxmhnk0fuHdcFCZAg8MUD3hdJX4Y14QwnYVIMMeta || {},
    component: () => import("/codebuild/output/src713742779/src/src/pages/membership/yumenavi/register.vue")
  },
  {
    name: "membership-yumenavi-confirm-code",
    path: "/membership/yumenavi/confirm-code",
    meta: confirm_45code_45SHib8baAeZhFw8F3ajvQoaOcYpJf5xO8gCjB3bms2MMeta || {},
    component: () => import("/codebuild/output/src713742779/src/src/pages/membership/yumenavi/confirm-code.vue")
  },
  {
    name: "mypage-membership-email-edit",
    path: "/mypage/membership/email-edit",
    component: () => import("/codebuild/output/src713742779/src/src/pages/mypage/membership/email-edit/index.vue")
  },
  {
    name: "monthly-close-applicationId",
    path: "/monthly/close/:applicationId()",
    component: () => import("/codebuild/output/src713742779/src/src/pages/monthly/close/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit",
    path: "/mypage/membership/others-edit",
    component: () => import("/codebuild/output/src713742779/src/src/pages/mypage/membership/others-edit/index.vue")
  },
  {
    name: "monthly-cancel-applicationId",
    path: "/monthly/cancel/:applicationId()",
    component: () => import("/codebuild/output/src713742779/src/src/pages/monthly/cancel/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-update",
    path: "/mypage/membership/others-edit/update",
    component: () => import("/codebuild/output/src713742779/src/src/pages/mypage/membership/others-edit/update.vue")
  },
  {
    name: "mypage-membership-email-edit-complete",
    path: "/mypage/membership/email-edit/complete",
    component: () => import("/codebuild/output/src713742779/src/src/pages/mypage/membership/email-edit/complete.vue")
  },
  {
    name: "mypage-membership-others-edit-confirm",
    path: "/mypage/membership/others-edit/confirm",
    component: () => import("/codebuild/output/src713742779/src/src/pages/mypage/membership/others-edit/confirm.vue")
  },
  {
    name: "monthly-payments-applicationId",
    path: "/monthly/payments/:applicationId()",
    component: () => import("/codebuild/output/src713742779/src/src/pages/monthly/payments/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-complete",
    path: "/mypage/membership/others-edit/complete",
    component: () => import("/codebuild/output/src713742779/src/src/pages/mypage/membership/others-edit/complete.vue")
  },
  {
    name: "mypage-membership-password-edit-update",
    path: "/mypage/membership/password-edit/update",
    component: () => import("/codebuild/output/src713742779/src/src/pages/mypage/membership/password-edit/update.vue")
  },
  {
    name: "monthly-applicant-applicationId",
    path: "/monthly/applicant/:applicationId()",
    component: () => import("/codebuild/output/src713742779/src/src/pages/monthly/applicant/[applicationId]/index.vue")
  },
  {
    name: "monthly-preapplication-parkingId",
    path: "/monthly/preapplication/:parkingId()",
    component: () => import("/codebuild/output/src713742779/src/src/pages/monthly/preapplication/[parkingId]/index.vue")
  },
  {
    name: "mypage-membership-password-edit-complete",
    path: "/mypage/membership/password-edit/complete",
    component: () => import("/codebuild/output/src713742779/src/src/pages/mypage/membership/password-edit/complete.vue")
  },
  {
    name: "monthly-application-applicationId",
    path: "/monthly/application/:applicationId()",
    component: () => import("/codebuild/output/src713742779/src/src/pages/monthly/application/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-email-edit-confirm-code",
    path: "/mypage/membership/email-edit/confirm-code",
    component: () => import("/codebuild/output/src713742779/src/src/pages/mypage/membership/email-edit/confirm-code.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi",
    path: "/mypage/membership/others-edit/yumenavi",
    component: () => import("/codebuild/output/src713742779/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue")
  },
  {
    name: "monthly-payments-method-applicationId",
    path: "/monthly/payments/method/:applicationId()",
    component: () => import("/codebuild/output/src713742779/src/src/pages/monthly/payments/method/[applicationId]/index.vue")
  },
  {
    name: "monthly-renewalcontract-applicationId",
    path: "/monthly/renewalcontract/:applicationId()",
    component: () => import("/codebuild/output/src713742779/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-update",
    path: "/mypage/membership/others-edit/yumenavi/update",
    component: () => import("/codebuild/output/src713742779/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-confirm",
    path: "/mypage/membership/others-edit/yumenavi/confirm",
    component: () => import("/codebuild/output/src713742779/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue")
  }
]